import { useEffect, useState } from "react";
import Layout from "../components/Layout";
import { api } from "../lib/api";
import { fmtDate } from "../lib/format";
import { FileText, FolderOpen, Download } from "lucide-react";

export default function ScoutingDocs() {
  const [docs, setDocs] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => {
    api.get("/td/dashboard").then((r) => setDocs(r.data?.scouting_docs || []));
  }, []);

  const filtered = docs.filter((d) => !q || d.title.toLowerCase().includes(q.toLowerCase()) || d.tag.toLowerCase().includes(q.toLowerCase()));

  return (
    <Layout title="Shared scouting docs" subtitle="Tech director · scouting knowledge base">
      <div className="space-y-5" data-testid="scouting-docs-root">
        <div className="pm-card p-4 flex items-center gap-3">
          <FolderOpen size={16} className="text-slate-400" />
          <input
            className="pm-input flex-1"
            placeholder="Search by title or tag…"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            data-testid="scouting-search"
          />
          <span className="pm-pill pm-pill-amber text-[10px]">MOCKED VAULT</span>
        </div>
        <div className="pm-card divide-y divide-slate-100">
          {filtered.map((d) => (
            <div key={d.id} className="p-4 flex items-center gap-4" data-testid={`doc-${d.id}`}>
              <div className="w-10 h-10 rounded-xl bg-emerald-50 flex items-center justify-center text-emerald-700 shrink-0">
                <FileText size={16} />
              </div>
              <div className="flex-1 min-w-0">
                <div className="font-display font-bold truncate">{d.title}</div>
                <div className="text-xs text-slate-500 truncate">{d.author} · {fmtDate(d.uploaded_at)} · {(d.size_kb / 1024).toFixed(1)} MB</div>
              </div>
              <span className="pm-pill pm-pill-slate text-[10px]">{d.tag}</span>
              <button
                onClick={() => {
                  api.post("/audit-log/document-event", { action: "document_download", record_type: "scouting_doc", record_id: d.id, title: d.title }).catch(() => {});
                  // simulated download (mocked vault) — opens in new tab
                  window.open(`#doc-${d.id}`, "_self");
                }}
                className="pm-btn-secondary h-9 px-3 rounded-lg text-xs font-bold flex items-center gap-1.5"
                data-testid={`doc-download-${d.id}`}
              >
                <Download size={12} /> Download
              </button>
            </div>
          ))}
          {filtered.length === 0 && <div className="p-8 text-center text-slate-500 text-sm" data-testid="docs-empty">No documents match your search.</div>}
        </div>
      </div>
    </Layout>
  );
}
